var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 20,
    fill: "#171717",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.75 20.5C31.75 18.8431 33.0931 17.5 34.75 17.5C36.4069 17.5 37.75 18.8431 37.75 20.5C37.75 22.1569 36.4069 23.5 34.75 23.5C33.8933 23.5 33.1212 23.1407 32.5751 22.5662L24.1539 27.2447C24.2167 27.4863 24.25 27.7395 24.25 28C24.25 28.2605 24.2167 28.5137 24.1539 28.7553L32.5751 33.4338C33.1212 32.8593 33.8933 32.5 34.75 32.5C36.4069 32.5 37.75 33.8431 37.75 35.5C37.75 37.1569 36.4069 38.5 34.75 38.5C33.0931 38.5 31.75 37.1569 31.75 35.5C31.75 35.2395 31.7833 34.9863 31.8461 34.7447L23.4249 30.0662C22.8788 30.6407 22.1067 31 21.25 31C19.5931 31 18.25 29.6569 18.25 28C18.25 26.3431 19.5931 25 21.25 25C22.1067 25 22.8788 25.3593 23.4249 25.9338L31.8461 21.2553C31.7833 21.0137 31.75 20.7605 31.75 20.5Z",
    fill: "#46494B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.435cf21dd6b25817c55c0e1a16e6351f.svg";
export { ForwardRef as ReactComponent };